import { Check } from "lucide-react";
import { useT, useLocale, LOCALES, LOCALE_LABEL, type Locale } from "../lib/i18n";
import { SheetShell } from "./SheetShell";
import { Button } from "./ui/Button";

const FLAG: Record<Locale, string> = {
  en: "🇬🇧",
  de: "🇩🇪",
  es: "🇪🇸",
  fr: "🇫🇷",
  it: "🇮🇹",
};

interface Props {
  open: boolean;
  onClose: () => void;
}

export function LanguageSheet({ open, onClose }: Props) {
  const t = useT();
  const { locale, setLocale } = useLocale();

  if (!open) return null;

  return (
    <SheetShell variant="center" onClose={onClose}>
      <h3 className="text-lg font-semibold mt-4 mb-4">{t("language_sheet.title")}</h3>

      <div className="bg-surface rounded-2xl overflow-hidden divide-y divide-line">
        {LOCALES.map((l) => (
          <button
            key={l}
            type="button"
            onClick={() => setLocale(l)}
            aria-pressed={locale === l}
            className="w-full flex items-center gap-3 px-4 py-3.5 text-left active:bg-surface-strong"
          >
            <span aria-hidden="true" className="text-xl">{FLAG[l]}</span>
            <span className="flex-1 text-sm">{LOCALE_LABEL[l]}</span>
            {locale === l && <Check size={18} className="text-brand" aria-hidden="true" />}
          </button>
        ))}
      </div>

      <Button fullWidth onClick={onClose} className="mt-4 mb-2">
        {t("language_sheet.done")}
      </Button>
    </SheetShell>
  );
}
